
import { LearnStatType, SpeedKind } from '../../../Constant';
import { ALM_KIND_SET, ALM_SMM_DAT } from '../../molecules/Grid/AlarmGrid';

export type V_DEV_LIST = {
  DEV_INDEX: number;
  DEV_NO: string;
  DEV_NAME: string;
  PLC_NO?: number;
  SET_NO?: number;
  SPEED?: number;
  STAT?: number;
  LOG_INT?: number;
  DSP_STR: string;
  COL_TIME?: Date;
  COL_MODE?: number;
  STATUS?: number;
  LEARN_STAT?: LearnStatType;
  SCHEDULE_TIME?: Date;
  LEARN_1_V?: number;
  LEARN_1_C?: number;
  LEARN_2_V?: number;
  LEARN_2_C?: number;
  LEARN_3_V?: number;
  LEARN_3_C?: number;
  CV_V?: number;
  CV_C?: number;
  STAT_CON?: number;
  SPD_UP_FREQ?: number;
  SPD_LO_FREQ?: number;
};

export type DeviceLists = Array<{
  V_DEV_LIST_DISP: V_DEV_LIST;
  V_DEV_LISTS: V_DEV_LIST[];
  IsManualColection: number;
  IsLearning: boolean;
}>;

export type DeviceAlarmData = {
  ALM_SMM_DAT: ALM_SMM_DAT;
  ALM_KIND_SET: ALM_KIND_SET;
};

export const deviceListValidate = (data: DeviceLists) => {
  if (data.length === 0 || data[0].V_DEV_LIST_DISP === undefined) return false;
  return true;
};

/**
 * ステータス異常の一覧取得
 * @param devIndex 
 * @returns 
 */
export const GetPlcStatuserrorList = (devIndex: string): Promise<DeviceAlarmData[]> => {
  return new Promise((resolve, reject) => {
    const url = 'api/AlarmSummary/PlcStatusAlarmList?'
    var param = `devIndex=${devIndex}`;
    fetch(`${url}${param}`)
      .then((res) => res.json())
      .then((result: DeviceAlarmData[]) => {
        console.debug(`${url}${param}`);
        console.debug(['GetPlcStatuserrorList result', result]);
        resolve(result);
      },
        (error) => {
          console.log(error);
          reject(error);
        });
  });
}
